import React from 'react';
import { AlertTriangleIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutNote, checkoutUrl, offer, scarcity } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-78" data-mp="15bsnljbdccl5">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-79" data-mp="1jcliw69hvbpb">
        {showUrgency && <div className="mx-auto max-w-narrow text-center" data-id="element-80" data-mp="1eebqu4j2gr7x">
            <p className="inline-flex items-center gap-2 rounded-xl bg-alert-50 px-4 py-2.5 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-alert-600 ring-1 ring-alert-100" data-id="element-81" data-mp="1ebxuztgkbazb">
              <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="1o4n108tcfwn9" />
              Quedan {scarcity.left} de {scarcity.total} cupos
            </p>
            <h2 className="mt-6 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-83" data-mp="1x5b62e0remo0">
              Después de estos {scarcity.total}, sale {scarcity.nextPrice}
            </h2>
          </div>}

        <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-8 text-center shadow-lift ring-2 ring-blue-600" data-id="element-84" data-mp="s4xrbnemnvp9">
          <h3 className="font-display text-lg font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-85" data-mp="x64wrftasisr">
            {offer.name}
          </h3>
          <p className="mt-2 text-blue-900/70" data-id="element-86" data-mp="163fbjb5bqq2f">{offer.summary}</p>
          <p className="mt-6" data-id="element-87" data-mp="1b39zp6xpt1js">
            <span className="block text-base text-blue-900/45 line-through" data-id="element-88" data-mp="1b2i4vybxz7uk">
              {offer.listPrice}
            </span>
            <span className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-89" data-mp="1fv1rtlwirfc1">
              {offer.price}
              <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-90" data-mp="1psfu8hlly3lc">USD</span>
            </span>
          </p>
          <div className="mt-7" data-id="element-91" data-mp="1ttjdle2v6hrb">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-92" data-mp="1tuko9hfyx28i">
              {offer.cta}
            </CtaButton>
            <p className="mt-3 text-sm text-blue-900/60" data-id="element-93" data-mp="3qskvmj8ou6rr">{checkoutNote}</p>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-94" data-mp="3lxf85fzn0k1k">
            <li className="inline-flex items-center gap-1.5" data-id="element-95" data-mp="3uwai935syea5">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-96" data-mp="3uupimz4ms55f" /> Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-97" data-mp="ddy0u9r8x09h">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-98" data-mp="8fmonsdhado3" /> Descarga en 2 minutos
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-99" data-mp="mf5swa3654v4">
              <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-100" data-mp="iec8vrsuka7i" /> Garantía 7
              días
            </li>
          </ul>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-101" data-mp="2o9wqtgrwu9ly">
          Tu próximo examen ya tiene fecha. Esto no.
        </p>
      </div>
    </section>;
}